import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export default function SortableStampItem({ stamp }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: stamp._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: "grab",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="flex items-center justify-center relative"
    >
      <img
        className="w-full h-auto rounded block"
        src={stamp.image}
        alt={stamp.subject || "Stamp"}
        loading="lazy"
        draggable={false}
      />
      {isDragging && (
        <div className="absolute inset-0 border-2 border-white rounded pointer-events-none" />
      )}
    </div>
  );
}
